function s2ab(input: string) {
  const buffer = new ArrayBuffer(input.length)
  const view = new Uint8Array(buffer)

  for (let i = 0; i < input.length; i++) {
    view[i] = input.charCodeAt(i) & 0xff
  }

  return buffer
}

function downloadUrl(url: string, filename: string) {
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.URL.revokeObjectURL(url)
}

export function downloadCsvFrom(data: string, filename = 'export.csv') {
  const url = window.URL.createObjectURL(
    new Blob([data], { type: 'text/csv' })
  )
  downloadUrl(url, filename)
}

export function downloadXlsxFrom(data: string, filename = 'export.xlsx') {
  const url = window.URL.createObjectURL(
    new Blob(
      [s2ab(atob(data))],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
    )
  )
  downloadUrl(url, filename)
}